import { createSlice } from '@reduxjs/toolkit'
import { getCruiseShips, addCruiseShip, removeCruiseShip, editCruiseShip } from './thunks'

const initialState = {
  ships: [],
  error: null,
  status: 'idle',
  lastFetched: null,
}

export const cruiseShipsSlice = createSlice({
  name: 'cruiseShips',
  initialState,
  reducers: {
    resetCruiseShipStatus: (state) => {
      state.status = 'idle';
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCruiseShips.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(getCruiseShips.fulfilled, (state, action) => {
      state.ships = action.payload || []
      state.status = 'successful'
      state.lastFetched = Date.now()
    })
    builder.addCase(getCruiseShips.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.error
    })
    builder.addCase(addCruiseShip.fulfilled, (state, action) => {
      state.ships.push(action.payload)
    })
    builder.addCase(removeCruiseShip.fulfilled, (state, action) => {
      state.ships = state.ships.filter(e => e.id !== action.payload)
    })
    builder.addCase(editCruiseShip.fulfilled, (state, action) => {
      const payload = action.payload
      if (payload && payload.id) {
        state.ships = state.ships.map(e => e.id === payload.id ? payload : e)
      }
    })
  }
})

export const cruiseShipsSelector = (state) => state.cruiseShips.ships

export const activeCruiseShipsSelector = (state) => 
  state.cruiseShips.ships.filter(s => s.active === true)

export const { resetCruiseShipStatus } = cruiseShipsSlice.actions

export default cruiseShipsSlice.reducer
